import { AlertContext } from 'contexts/AlertContext'
import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import { POST } from 'api/request'
import * as urls from 'api/urls'
import Modal from './Modal'
import Loader from 'components/Loader'

interface ProfilePasswordModalProps {
  has_password?: boolean
  setProfileData: (data: board.BoardResponse) => void
  onClose: base.BasicFunc
}

const ProfilePasswordModal: React.FC<ProfilePasswordModalProps> = ({ has_password, onClose, setProfileData }) => {
  const [isLoading, setLoading] = useState(false)
  const [isPassword, showPassword] = useState(!!has_password)
  const [password, setPassword] = useState('')
  const params = useParams()

  const { showAlert } = useContext(AlertContext)

  const handleSubmit = async () => {
    if (isLoading) return
    setLoading(true)
    try {
      const response = await POST<board.BoardResponse>(urls.updatedBoard(params['*']), {
        body: { password }
      })
      if (response.ok) {
        showAlert('Zaktualizowano zabezpieczenie profilu', 'success')
        // window.history.back()
        onClose()
        setProfileData(response.data)
      } else {
        throw new Error('Wystąpił błąd :/')
      }
    } catch (err) {
      showAlert('Wystąpił błąd :/', 'error')
      setLoading(false)
    }
  }

  return (
    <Modal
      icon="settings"
      onClose={onClose}
      title='Zabezpieczenia profilu'
      primaryDisabled={isPassword && !password}
      primaryButton={password && has_password ? 'Zmień hasło' : 'Zapisz'}
      primaryButtonAction={handleSubmit}
      secondaryButton="Anuluj"
      secondaryButtonAction='close'>
      {isLoading
        ? <div className='--minHeight'><Loader type='full' /></div>
        : <div className='modal__form'>
          <div className='modal__profileSettings'>
            <div
              className="item toggle"
              onClick={() => {
                if (isPassword && password) {
                  setPassword('')
                }
                showPassword(!isPassword)
              }}>
              {isPassword ? "Włączone hasło" : "Wyłączone hasło"}
              <div className={`box ${isPassword && 'active'}`}>
                <div className="circle"></div>
              </div>
            </div>
          </div>
          <div
            className='myInput'
            style={isPassword ? undefined : { opacity: 0.5 }}>
            <label>Hasło</label>
            <input
              disabled={!isPassword}
              value={password}
              onChange={e => {
                setPassword(e.target.value)
              }}
            />
          </div>
        </div>}
    </Modal>)
}

export default ProfilePasswordModal